export const mapFilterStatic = (columns) => {
  const filterStatic = [];

  columns.forEach((column) => {
    switch (column.type) {
      case 'cpfCnpj':
      case 'cep':
      case 'text':
        makeTextFilter(filterStatic, column);
        break;
      case 'date':
        makeDateFilter(filterStatic, column);
        break;
      case 'number':
        makeNumberFilter(filterStatic, column);
        break;
      case 'decimal':
        makeDecimalFilter(filterStatic, column);
        break;
      case 'lista':
        makeListFilter(filterStatic, column);
        break;
      default:
        break;
    }
  });

  return filterStatic;
};

export const makeTextFilter = (filterStatic, column) => {
  const mount = (input, filter, value) => {
    if (value) {
      let filterItem;
      if (input.operation == 'contains') {
        filterItem = makeFilterField(column.dataName, input.isNot ? 'doesnotcontain' : 'contains', value);
      } else {
        filterItem = makeFilterField(
          column.dataName,
          input.isNot ? (dataValue) => !_.startsWith(_.toLower(dataValue), _.toLower(value)) : 'startswith',
          value
        );
      }

      filterItem && filter.push(filterItem);
    }
  };

  column.inputs.forEach((input) => {
    let filter = {
      logic: 'and',
      filters: [],
    };

    if (input.advancedSearchValues?.length > 0) {
      filter.logic = 'or';
      input.advancedSearchValues?.forEach((value) => mount(input, filter.filters, value));
    } else {
      mount(input, filter.filters, input.value);
    }

    if (filter.filters.length > 0) filterStatic.push(filter);
  });
};

export const makeNumberFilter = (filterStatic, column) => {
  const mount = (input, filter, value, isAdvancedSearch) => {
    if (value) {
      value = parseInt(value);
      let filterItem;
      if (input.operation == 'de') {
        filterItem = makeFilterField(column.dataName, isAdvancedSearch ? (input.isNot ? 'neq' : 'eq') : 'gte', value);
      } else {
        filterItem = makeFilterField(column.dataName, 'lte', value);
      }

      filterItem && filter.push(filterItem);
    }
  };

  column.inputs.forEach((input) => {
    let filter = {
      logic: 'and',
      filters: [],
    };

    if (input.advancedSearchValues && input.advancedSearchValues?.length > 0) {
      filter.logic = 'or';
      input.advancedSearchValues?.forEach((value) => mount(input, filter.filters, value, true));
    } else {
      mount(input, filter.filters, input.value);
    }
    if (filter.filters.length > 0) filterStatic.push(filter);
  });
};

export const makeDecimalFilter = (filterStatic, column) => {
  const mount = (input, filter, value, isAdvancedSearch) => {
    if (value) {
      value = parseFloat(value);
      let filterItem;
      if (input.operation == 'de') {
        filterItem = makeFilterField(column.dataName, isAdvancedSearch ? (input.isNot ? 'neq' : 'eq') : 'gte', value);
      } else {
        filterItem = makeFilterField(column.dataName, 'lte', value);
      }

      filterItem && filter.push(filterItem);
    }
  };

  column.inputs.forEach((input) => {
    let filter = {
      logic: 'and',
      filters: [],
    };

    if (input.advancedSearchValues && input.advancedSearchValues?.length > 0) {
      filter.logic = 'or';
      input.advancedSearchValues?.forEach((value) => mount(input, filter.filters, value, true));
    } else {
      mount(input, filter.filters, input.value);
    }
    if (filter.filters.length > 0) filterStatic.push(filter);
  });
};

export const makeDateFilter = (filterStatic, column) => {
  const mount = (dataName, operator, value) => {
    filterStatic.push(makeFilterField(dataName, operator, value));
  };
  const mountDate = (input) => {
    var result = input.value.split('/');
    var newDate = `${result[2]}-${result[1]}-${result[0]}`;

    return new Date(`${newDate}T${input.valueTime}`);
  };

  const inputDe = column.inputs[0];
  const inputAte = column.inputs[1];

  if (inputDe.value || inputAte.value) {
    let filter = {
      logic: 'and',
      filters: [],
    };

    if (inputDe.value && inputAte.value) {
      let valueDe = mountDate(inputDe);
      let valueAte = mountDate(inputAte);

      if (valueDe.getTime() != valueAte.getTime()) {
        mount(column.dataName, 'gte', mountDate(inputDe));
        mount(column.dataName, 'lte', mountDate(inputAte));
      } else {
        mount(column.dataName, 'eq', valueDe);
        mount(column.dataName, 'eq', valueAte);
      }
    } else if (inputDe.value) {
      mount(column.dataName, 'gte', mountDate(inputDe));
    } else {
      mount(column.dataName, 'lte', mountDate(inputAte));
    }

    filterStatic.push(filter);
  }
};

export const makeListFilter = (filterStatic, column) => {
  let filter = {
    logic: 'or',
    filters: column.inputs
      .filter((x) => x.check)
      .map((x) => {
        return makeFilterField(column.dataName, 'eq', x.value);
      }),
  };
  if (filter.filters.length > 0) filterStatic.push(filter);
};

export const makeFilterField = (field, operator, value) => {
  return { field, operator, value, ignoreCase: true };
};
